/* global axios */

import ApiClient from './ApiClient';

class MetaBusinessAgentAPI extends ApiClient {
  constructor() {
    super('integrations/meta_business_agent', { accountScoped: true });
  }

  hookUrl(hookId, path = '') {
    return `${this.url}/${hookId}${path}`;
  }

  getEligibility(hookId) {
    return axios.get(this.hookUrl(hookId, '/eligibility'));
  }

  getSettings(hookId) {
    return axios.get(this.hookUrl(hookId, '/settings'));
  }

  updateSettings(hookId, payload) {
    return axios.put(this.hookUrl(hookId, '/settings'), payload);
  }

  getBusinessInfo(hookId) {
    return axios.get(this.hookUrl(hookId, '/business_info'));
  }

  updateBusinessInfo(hookId, payload) {
    return axios.put(this.hookUrl(hookId, '/business_info'), payload);
  }

  listFaqs(hookId) {
    return axios.get(this.hookUrl(hookId, '/faqs'));
  }

  createFaq(hookId, payload) {
    return axios.post(this.hookUrl(hookId, '/faqs'), payload);
  }

  deleteFaq(hookId, id) {
    return axios.delete(this.hookUrl(hookId, `/faqs/${id}`));
  }

  listWebsites(hookId) {
    return axios.get(this.hookUrl(hookId, '/websites'));
  }

  createWebsite(hookId, url) {
    return axios.post(this.hookUrl(hookId, '/websites'), { url });
  }

  deleteWebsite(hookId, id) {
    return axios.delete(this.hookUrl(hookId, `/websites/${id}`));
  }

  listFiles(hookId) {
    return axios.get(this.hookUrl(hookId, '/files'));
  }

  uploadFile(hookId, file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('file_name', file.name);
    return axios.post(this.hookUrl(hookId, '/files'), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  deleteFile(hookId, id) {
    return axios.delete(this.hookUrl(hookId, `/files/${id}`));
  }

  listSkills(hookId) {
    return axios.get(this.hookUrl(hookId, '/skills'));
  }

  createSkill(hookId, payload) {
    return axios.post(this.hookUrl(hookId, '/skills'), payload);
  }

  deleteSkill(hookId, id) {
    return axios.delete(this.hookUrl(hookId, `/skills/${id}`));
  }

  listUiSkills(hookId) {
    return axios.get(this.hookUrl(hookId, '/ui_skills'));
  }

  createUiSkill(hookId, payload) {
    return axios.post(this.hookUrl(hookId, '/ui_skills'), payload);
  }

  deleteUiSkill(hookId, id) {
    return axios.delete(this.hookUrl(hookId, `/ui_skills/${id}`));
  }

  listAllowlistEntries(hookId) {
    return axios.get(this.hookUrl(hookId, '/allowlist_entries'));
  }

  createAllowlistEntry(hookId, consumerPhoneNumber) {
    return axios.post(this.hookUrl(hookId, '/allowlist_entries'), {
      consumer_phone_number: consumerPhoneNumber,
    });
  }

  deleteAllowlistEntry(hookId, id) {
    return axios.delete(this.hookUrl(hookId, `/allowlist_entries/${id}`));
  }

  listConnectors(hookId) {
    return axios.get(this.hookUrl(hookId, '/connectors'));
  }

  createConnector(hookId, payload) {
    return axios.post(this.hookUrl(hookId, '/connectors'), payload);
  }

  deleteConnector(hookId, id) {
    return axios.delete(this.hookUrl(hookId, `/connectors/${id}`));
  }

  upsertConnectorApiKey(hookId, id, apiKeyConfig) {
    return axios.post(
      this.hookUrl(hookId, `/connectors/${id}/upsert_api_key`),
      {
        api_key_config: apiKeyConfig,
      }
    );
  }

  runAgentTest(hookId, payload) {
    return axios.post(this.hookUrl(hookId, '/agent_test'), payload);
  }

  listConnectorBundles(hookId) {
    return axios.get(this.hookUrl(hookId, '/connector_bundles'));
  }

  activateConnectorBundle(hookId, bundleKey) {
    return axios.post(this.hookUrl(hookId, `/connector_bundles/${bundleKey}`));
  }
}

export default new MetaBusinessAgentAPI();
